module.exports = __webpack_public_path__ + "static/Dan-0f7af1e013b2d253746d94515a584022.png";